import React from "react";

export const SuperUserNavigationMenu = (props) => {
	const {selectedMenuOption, setSelectedMenuOption} = props;
	const [hoveredOptionIndex, setHoveredOptionIndex] = React.useState(null);

	const links = [
		{name: 'Analytics'},
		{name: 'Profile Claims'},
		{name: 'Users'},
		{name: 'Events'},
		{name: 'Broadcast'}
	];

	return (
		<div
			className="min-w-60 w-60 max-w-60 bg-white shadow-xl shadow-black/25
                h-full hidden landscape:md:block rounded-xl
                portrait:p-[0.4rem] portrait:sm:p-[0.65rem] portrait:jk:p-[0.5rem]
                landscape:p-[0.4rem] landscape:jk:p-[0.4rem]"
		>
			<nav className="flex flex-col gap-1">
				{links.map((link, index) => (
					<button
						key={index}
						onClick={() => setSelectedMenuOption(link.name)}
						className={`flex items-center gap-2 rounded-lg
                            portrait:py-[0.75rem] portrait:pl-[1.25rem] portrait:pr-[1rem]
                            landscape:py-[0.5rem] landscape:px-[1rem]

                            ${hoveredOptionIndex === index || selectedMenuOption === link.name ? 'bg-gray-900' : 'bg-white'}
                            transition duration-500 ease-in-out

                            relative after:content-[''] after:absolute
                            after:right-0 after:bottom-0 after:left-0
                            after:h-[1.5px] after:bg-[length:10px_1px]
                            after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]`}
						onMouseEnter={() => setHoveredOptionIndex(index)}
						onMouseLeave={() => setHoveredOptionIndex(null)}
						onTouchStart={() => setHoveredOptionIndex(index)}
						onTouchEnd={() => setHoveredOptionIndex(null)}
					>
						<p
							className={`font-custom-semi-bold transition duration-500 ease-in-out
                                ${(hoveredOptionIndex === index || selectedMenuOption === link.name) ? 'text-gray-300' : 'text-gray-900'}
                                portrait:text-[1.1rem] portrait:sm:text-[1.3rem]
                                landscape:text-[1.15rem] landscape:sm:text-[1.05rem]`}
						>
							{link.name}
						</p>
					</button>
				))}
			</nav>
		</div>
	);
};
